<section>
  <label
    *ngIf="label"
    class="form-label d-block"
    [translatable]="{
      transKey: translationKey,
      modEnum: selectedTranslationModuleEnum
    }"
  >
    {{ label }}
    <span class="{{ isRequired ? 'astrix-red' : 'astrix-transparent' }}">
      *
    </span>
  </label>

  <ng-container *ngIf="loading; else files">
    <div class="my-4">
      <ng-container [ngTemplateOutlet]="skeleton"></ng-container>
    </div>
  </ng-container>

  <ng-template #files>
    <div class="d-flex flex-wrap">
      <div>
        <label for="file">
          <div
            [ngClass]="mode"
            class="img-container text-center pt-3"
            *ngIf="!disabled"
          >
            <img
              src="./assets/img/15.svg"
              style="width: 160px !important; height: 100px !important"
            />
            <div class="icon-upload">
              <span class="upload">
                <i class="bx bx-upload fs-3"></i>
              </span>
            </div>
            <div class="upload-text">
              {{ "shared.uploadImages" | translate }}
              <div>
                {{ language == "en" ? "Max Size " : "اقصي حجم " }}
                {{ maxFileSizeInMB }} {{ language == "en" ? "MB" : "ميجابايت" }}
              </div>
            </div>

            <input
              hidden
              #attachments
              id="file"
              type="file"
              [multiple]="isMultiFiles"
              [accept]="supportedAttachmentTypes.join(',')"
              (change)="onUploadFile($event)"
            />
          </div>
        </label>
      </div>
      <!-- old images  -->
      <div *ngFor="let img of _oldAttachments; index as i">
        <div [ngClass]="mode" class="img-container">
          <img [src]="img.fileUrl" />
          <div class="icons">
            <span class="edit" *ngIf="!disabled && showEdit">
              <label for="file{{ i }}">
                <i class="bx bx-edit"></i>
              </label>
            </span>
            <span class="delet" *ngIf="!disabled">
              <i class="bx bx-trash" (click)="onDeleteFile(i, 'old')"></i>
            </span>

            <input
              type="file"
              [accept]="supportedAttachmentTypes.join(',')"
              hidden
              (change)="onUpdateFile($event, i, 'old')"
              id="file{{ i }}"
            />
          </div>
        </div>
      </div>
      <!-- new images -->
      <div *ngFor="let img of returnedUploadedFiles; index as i">
        <div [ngClass]="mode" class="img-container">
          <img [src]="img.fileUrl" />
          <div class="icons">
            <span class="edit" *ngIf="showEdit">
              <label for="fileUpload{{ i }}">
                <i class="bx bx-edit"></i>
              </label>
            </span>

            <span class="delet">
              <i class="bx bx-trash" (click)="onDeleteFile(i, 'new')"></i>
            </span>
            <input
              type="file"
              hidden
              [accept]="supportedAttachmentTypes.join(',')"
              (change)="onUpdateFile($event, i, 'new')"
              id="fileUpload{{ i }}"
            />
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</section>

<!-- loader skeleton for the form -->
<ng-template #skeleton>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
  <app-skeleton-loader mode="table"></app-skeleton-loader>
</ng-template>
